import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles";
import * as serviceWorker from "./serviceWorker";
import ErrorBoundary from "./Errorboundary";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import AdvancedFormat from "dayjs/plugin/advancedFormat";
import RainbowKitWrapper from "./RainbowKitProvider";

dayjs.extend(AdvancedFormat); // use plugin

//getSiteConfig();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <ToastContainer hideProgressBar={false} theme="colored" />
    <RainbowKitWrapper>
      <App />
    </RainbowKitWrapper>
  </ErrorBoundary>
);

serviceWorker.unregister();
